import { Check, X } from 'lucide-react';
import { Avatar } from '@/components/inbox/Avatar';
import { clock } from '@/lib/voice/take';
import type { CallUi } from '@/hooks/useCallFlow';
import { useBackLayer } from '@/lib/backStack';

interface Props {
  call: CallUi;
  seed: number;
  channelType?: string;
  onClose: () => void;
}

const STEPS = ['АТС звонит на ваш телефон, ответьте', 'Соединяем с клиентом', 'Разговор идёт, запись включена'];

/** Наложение звонка (прототип, callOverlay): три шага обратного вызова через АТС и таймер разговора. */
export function CallOverlay({ call, seed, channelType, onClose }: Props) {
  // «Назад» на Андроиде прячет окно звонка (сам звонок, как и по ×, не прерывается).
  useBackLayer(onClose);
  return (
    <div className="call" role="dialog" aria-modal="true" aria-label="Звонок">
      <Avatar name={call.name} seed={seed} channelType={channelType} />
      <h3>{call.name}</h3>
      <div className="num tnum">{call.phone}</div>
      {call.error ? (
        <p className="callerr" role="alert">{call.error}</p>
      ) : (
        <div className="steps" role="list">
          {STEPS.map((text, i) => {
            const state = call.ended || call.step > i ? 'ok' : call.step === i ? 'on' : '';
            return (
              <div key={text} role="listitem" className={`st ${state}`}>
                <i><Check aria-hidden /></i>{text}
              </div>
            );
          })}
        </div>
      )}
      <div className="timer tnum" aria-live="off">{call.step >= 2 && !call.error ? clock(call.seconds) : ''}</div>
      {call.ended && <p className="callnote" role="status">Разговор завершён. Запись и расшифровка появятся в карточке сделки.</p>}
      {call.note && !call.ended && <p className="callnote" role="status">{call.note}</p>}
      <button type="button" className="hang" onClick={onClose} aria-label={call.ended || call.error ? 'Закрыть' : 'Закрыть окно (звонок не прервётся)'}>
        <X aria-hidden />
      </button>
      <div className="callnote">Так работает обратный вызов через АТС. Завершить разговор можно на телефоне.</div>
    </div>
  );
}
